export type DramaStatus = 'ongoing' | 'twist' | 'ended';
export type TimelineType = 'start' | 'update' | 'twist' | 'ending';

export interface TimelineEntry {
  date: string;
  title: string;
  content: string;
  type: TimelineType;
}

export interface Drama {
  id: string;
  title: string;
  category: string;
  status: DramaStatus;
  heat: number;
  summary: string;
  cover: string;
  participants: string[];
  tags: string[];
  startedAt: string;
  updatedAt: string;
  progress: number;
  timeline: TimelineEntry[];
}

export const dramas: Drama[] = [
  {
    id: 'he-yue-luo-sheng-men',
    title: '顶流歌手解约罗生门：一纸合约撕出五个版本',
    category: 'yule',
    status: 'twist',
    heat: 9860,
    summary: '歌手「林晚星」宣布单方面解约，工作室、前东家、代理律师各说各话，同一条合约在不同人嘴里出现五个版本。',
    cover:
      'https://readdy.ai/api/search-image?query=dark%20moody%20concert%20stage%20with%20single%20spotlight%20and%20empty%20microphone%20stand%2C%20theatrical%20dramatic%20atmosphere%2C%20deep%20red%20and%20shadow%20tones%2C%20editorial%20photography%2C%20stylized%20and%20abstract%2C%20no%20people&width=900&height=675&seq=xg-drama-stage-01&orientation=landscape',
    participants: ['歌手林晚星', '星野音乐（前东家）', '代理律师方'],
    tags: ['解约', '合约纠纷', '公关声明'],
    startedAt: '2026-07-18',
    updatedAt: '2026-09-06',
    progress: 68,
    timeline: [
      {
        date: '2026-07-18',
        title: '凌晨一条动态，风波开场',
        content:
          '林晚星在个人账号发布长文，指称合作期间长期被安排超量行程、分成比例与口头承诺不符，宣布即刻终止与星野音乐的经纪约。配图是一张手写便签，「不想再演了」五个字被反复转发。',
        type: 'start',
      },
      {
        date: '2026-07-19',
        title: '前东家发声明，称合约尚在有效期',
        content:
          '星野音乐当日回应，强调双方合约距离到期还有两年一个月，单方面解约属于违约，已委托律师启动程序。声明中第一次抛出「分成比例」「违约金基数」两组数字。',
        type: 'update',
      },
      {
        date: '2026-07-24',
        title: '代理律师抛出时间线截图',
        content:
          '林晚星方律师整理出三年来所有通告的排期截图，指出其中有 47 天连续无休。律师同时公开一段沟通记录，表示曾多次就分成问题沟通未果，为解约提供了「合理理由」的说法。',
        type: 'update',
      },
      {
        date: '2026-08-11',
        title: '反转：前东家放出补充协议',
        content:
          '星野音乐突然公开一份双方签字盖章的补充协议扫描件，其中约定了新的分成方案与休整期安排。此举直接推翻「口头承诺未兑现」的说法，舆论一夜之间开始转向。',
        type: 'twist',
      },
      {
        date: '2026-08-15',
        title: '再反转：协议被指签署时间存疑',
        content:
          '林晚星方回应称该协议签署当日其本人正在外地录制节目，行程可查，要求对方公开完整签署录像。双方围绕「协议是否有效」进入第二轮拉扯，互发三封律师函。',
        type: 'twist',
      },
      {
        date: '2026-09-06',
        title: '最新进度：进入调解程序',
        content:
          '双方确认已接受行业协会主持的调解，就违约金金额与合作期间的收益结算进行闭门协商。截至目前仍未达成一致，本瓜仍在更新中。',
        type: 'update',
      },
    ],
  },
  {
    id: 'xuan-pin-fan-che',
    title: '千万粉主播选品翻车：从爆单到集体退款只用了九天',
    category: 'wanghong',
    status: 'ended',
    heat: 8720,
    summary: '带货主播「阿泉」一场专场直播卖出六万单，九天后因产品质检问题引发集体退款，直播间从「家人们」变成维权现场。',
    cover:
      'https://readdy.ai/api/search-image?query=empty%20ring%20light%20and%20microphone%20in%20a%20modern%20live%20streaming%20studio%2C%20stacked%20unopened%20cardboard%20boxes%20in%20the%20background%2C%20moody%20amber%20lighting%2C%20stylized%20editorial%20photography%2C%20no%20people&width=900&height=675&seq=xg-drama-livestream-02&orientation=landscape',
    participants: ['主播阿泉', '供应商「禾田严选」', '平台方'],
    tags: ['带货', '质检', '集体退款'],
    startedAt: '2026-05-02',
    updatedAt: '2026-06-20',
    progress: 100,
    timeline: [
      {
        date: '2026-05-02',
        title: '一场六万单的专场',
        content:
          '阿泉在一场以「源头直供」为主题的专场直播中主推一款便携小家电，直播间实时在线人数突破八十万，单场成交六万单，创下该账号历史纪录。当场承诺「不满意无条件退」。',
        type: 'start',
      },
      {
        date: '2026-05-06',
        title: '首批买家晒出问题产品',
        content:
          '陆续有买家在社交平台反馈收到的小家电存在外壳接缝不均、通电后异响等问题，相关话题开始聚集。有用户对比了同款商品的官方渠道版本，指出做工存在差异。',
        type: 'update',
      },
      {
        date: '2026-05-11',
        title: '主播下架链接并暂停直播',
        content:
          '阿泉团队紧急下架该商品链接，宣布暂停直播三天进行自查，同时开通专属退款通道。当日晚间，供应商「禾田严选」首次回应，称批次差异属于「正常范围内的工艺波动」。',
        type: 'update',
      },
      {
        date: '2026-05-14',
        title: '第三方检测报告出炉',
        content:
          '平台方委托的第三方检测报告公布，样本中确有两项指标未达到宣传页面标注的标准。平台的介入让事件性质从「品质争议」升级为「宣传与实物不符」。',
        type: 'twist',
      },
      {
        date: '2026-06-20',
        title: '结局：全额退款 + 供应商退出合作',
        content:
          '阿泉发布致歉视频，宣布对全部订单执行全额退款并承担来回运费，同时终止与「禾田严选」的所有合作。平台对该供应商作出下架处理。事件最终以这封公开致歉收尾。',
        type: 'ending',
      },
    ],
  },
  {
    id: 'zongyi-cp-ju-ben',
    title: '综艺 CP 剧本疑云：一句「我们真没演」引爆三次反转',
    category: 'zongyi',
    status: 'ongoing',
    heat: 7640,
    summary: '恋爱综艺收官夜，嘉宾一句「我们真没演」被截成短视频疯传，随后剪辑片段流出，让「真假 CP」之争三次反转。',
    cover:
      'https://readdy.ai/api/search-image?query=softly%20lit%20empty%20reality%20show%20set%20with%20two%20chairs%20facing%20each%20other%20and%20film%20cameras%2C%20warm%20peach%20and%20cream%20tones%2C%20dreamy%20stylized%20editorial%20photography%2C%20no%20people&width=900&height=675&seq=xg-drama-tvcouple-03&orientation=landscape',
    participants: ['节目嘉宾', '节目组', '后期剪辑团队'],
    tags: ['综艺', '剧本', '剪辑争议'],
    startedAt: '2026-08-01',
    updatedAt: '2026-09-08',
    progress: 45,
    timeline: [
      {
        date: '2026-08-01',
        title: '收官夜的一句话',
        content:
          '节目收官直播中，一位嘉宾对搭档说「我们真没演」，被剪成十五秒短视频广泛传播。短短两小时内，相关话题冲上热榜，CP 粉丝与质疑「剧本」的观众分成两派。',
        type: 'start',
      },
      {
        date: '2026-08-03',
        title: '节目组回应：真实情感不设剧本',
        content:
          '节目组发布声明，称节目只设定场景与流程，不干预嘉宾表达，并对剪辑节奏作出说明。声明附上一段未播出的后台花絮，试图证明互动自然。',
        type: 'update',
      },
      {
        date: '2026-08-19',
        title: '反转：前工作人员爆料剪辑逻辑',
        content:
          '一位自称参与后期的网友发文，称部分互动画面被调换时间顺序以增强戏剧张力，并放出疑似分镜表截图。真实性尚未核实，但话题热度迅速回升。',
        type: 'twist',
      },
      {
        date: '2026-08-27',
        title: '再反转：截图被指拼接',
        content:
          '另一方网友逐帧比对后指出，爆料中的截图存在明显的字体与排版差异，疑为拼接制作。爆料者随后删除原帖，事件再次陷入各说各话的状态。',
        type: 'twist',
      },
      {
        date: '2026-09-08',
        title: '进度：等待正式回应',
        content:
          '节目组至今未就「分镜表截图」作出正式回应，两位嘉宾也保持沉默。该瓜目前仍处于进行中状态，后续进展将持续跟进。',
        type: 'update',
      },
    ],
  },
  {
    id: 'dui-du-xie-yi',
    title: '对赌协议翻车记：一家影视公司的三年之约与一地鸡毛',
    category: 'shangye',
    status: 'ended',
    heat: 6980,
    summary: '为了一笔投资，影视公司签下三年业绩对赌；三年后业绩未达标，创始人与投资方由伙伴变对手，走向仲裁。',
    cover:
      'https://readdy.ai/api/search-image?query=stack%20of%20unopened%20envelopes%20and%20a%20blank%20signed%20contract%20on%20a%20dark%20wooden%20table%2C%20single%20desk%20lamp%20glow%2C%20deep%20green%20and%20brass%20tones%2C%20stylized%20editorial%20photography%2C%20no%20people&width=900&height=675&seq=xg-drama-contract-04&orientation=landscape',
    participants: ['影创文化', '投资方「启明资本」', '创始团队'],
    tags: ['对赌', '融资', '仲裁'],
    startedAt: '2026-02-10',
    updatedAt: '2026-07-30',
    progress: 100,
    timeline: [
      {
        date: '2026-02-10',
        title: '创始人群里的一段长文',
        content:
          '影创文化创始人在行业社群发布长文，回忆三年前为获得融资签下业绩对赌的过程，称公司在市场下行期被迫承接大量低毛利项目，最终仍未完成承诺业绩。',
        type: 'start',
      },
      {
        date: '2026-03-05',
        title: '投资方回应：条款对双方公平',
        content:
          '启明资本回应称，对赌条款在签约前经双方多轮商议并由专业机构出具意见，投资方同样承担了资金风险，不存在单方面施压。双方开始各执一词。',
        type: 'update',
      },
      {
        date: '2026-04-22',
        title: '反转：一份补充备忘录流出',
        content:
          '一份据称是签约同期形成的补充备忘录在业内流传，其中提到「若行业政策发生重大变化，业绩考核可协商调整」。这一条款此前从未被公开提及。',
        type: 'twist',
      },
      {
        date: '2026-07-30',
        title: '结局：仲裁裁决，双方各自退让',
        content:
          '仲裁结果公布，认定业绩考核基数应作部分调整，创始团队需承担的补偿金额较原索赔大幅下降。双方均表示接受裁决，这场持续半年的商战正式落幕。',
        type: 'ending',
      },
    ],
  },
  {
    id: 'dian-jing-dai-da',
    title: '电竞代打风波：一份训练日志让冠军奖杯蒙上阴影',
    category: 'keji',
    status: 'twist',
    heat: 6310,
    summary: '一支黑马战队夺冠后被指决赛存在代打，一份流出的训练日志成为关键证据，联盟介入调查后案情两次反转。',
    cover:
      'https://readdy.ai/api/search-image?query=empty%20esports%20gaming%20arena%20with%20glowing%20neon%20keyboards%20and%20a%20trophy%20on%20a%20pedestal%2C%20teal%20and%20violet%20stage%20lighting%2C%20stylized%20abstract%20editorial%20photography%2C%20no%20people&width=900&height=675&seq=xg-drama-esports-05&orientation=landscape',
    participants: ['黑马战队「夜行」', '赛事联盟', '爆料网友'],
    tags: ['电竞', '代打', '联盟调查'],
    startedAt: '2026-06-12',
    updatedAt: '2026-09-02',
    progress: 58,
    timeline: [
      {
        date: '2026-06-12',
        title: '夺冠三天后，质疑出现',
        content:
          '黑马战队「夜行」在赛季总决赛中夺冠，三天后一位网友发帖，称决赛决胜局的操作习惯与队内首发选手以往的键位设置不符，怀疑存在代打。',
        type: 'start',
      },
      {
        date: '2026-06-18',
        title: '战队否认并公布训练记录',
        content:
          '战队发布声明坚决否认，同时公布部分训练记录以自证。然而公布的日志中，有两天的时间戳与选手当日的公开活动行程存在重叠，反而引发更多疑问。',
        type: 'update',
      },
      {
        date: '2026-07-04',
        title: '反转：疑似账号登录记录流出',
        content:
          '有网友提供一份据称是比赛当日的账号登录记录，显示该账号曾在异地登录。联盟随即宣布正式立案调查，并暂停相关人员参赛资格。',
        type: 'twist',
      },
      {
        date: '2026-09-02',
        title: '进度：调查报告延期公布',
        content:
          '原定于八月底公布的调查结论宣布延期，联盟表示需要补充核实设备日志。截至目前冠军归属仍未更改，本瓜持续更新。',
        type: 'update',
      },
    ],
  },
  {
    id: 'jia-meng-jiu-fen',
    title: '网红餐饮加盟纠纷：排队三小时的店，半年后集体关门',
    category: 'shangye',
    status: 'ended',
    heat: 5720,
    summary: '一家网红茶饮品牌靠短视频走红，半年内开出两百家加盟店，随后加盟商集体反映亏损，品牌方与加盟商各执一词。',
    cover:
      'https://readdy.ai/api/search-image?query=closed%20pastel%20bubble%20tea%20shop%20storefront%20with%20pulled%20down%20roller%20shutter%20and%20faded%20signage%2C%20quiet%20street%20in%20soft%20morning%20light%2C%20warm%20muted%20tones%2C%20stylized%20editorial%20photography%2C%20no%20people&width=900&height=675&seq=xg-drama-teashop-06&orientation=landscape',
    participants: ['品牌方「果然茶」', '加盟商群体', '招商平台'],
    tags: ['加盟', '餐饮', '维权'],
    startedAt: '2026-01-15',
    updatedAt: '2026-06-05',
    progress: 100,
    timeline: [
      {
        date: '2026-01-15',
        title: '一篇《加盟半年亏了四十万》',
        content:
          '一位加盟商发出长文，讲述自己缴纳加盟费、装修费、设备费后，开业半年累计亏损约四十万元。文章被大量转发，越来越多加盟商在评论区留言。',
        type: 'start',
      },
      {
        date: '2026-02-08',
        title: '品牌方回应：选址与运营系加盟商自主',
        content:
          '果然茶发布声明，称公司提供的是品牌授权与供应链支持，门店选址与日常运营由加盟商自主决定，亏损属于个别经营问题，并非普遍现象。',
        type: 'update',
      },
      {
        date: '2026-03-20',
        title: '反转：招商话术截图被公开',
        content:
          '多名加盟商公开招商阶段的沟通记录，其中出现「回本周期八到十个月」「公司统一选址保证客流」等表述，与品牌方后来「自主经营」的说法形成明显矛盾。',
        type: 'twist',
      },
      {
        date: '2026-06-05',
        title: '结局：品牌方同意分批退还部分费用',
        content:
          '经多方协商，果然茶与加盟商代表达成方案，对签约时间较短、尚未开业或开业不足三个月的门店分批退还部分加盟费，并停止新的招商。事件就此收尾。',
        type: 'ending',
      },
    ],
  },
  {
    id: 'duan-ju-chao-xi',
    title: '短剧抄袭指控：两部爆款只差一个姓氏',
    category: 'zongyi',
    status: 'twist',
    heat: 5240,
    summary: '两部同期上线的爆款短剧，剧情推进、台词节奏与分镜几乎一致，原创方提出抄袭指控，涉事方称「撞梗属于常态」。',
    cover:
      'https://readdy.ai/api/search-image?query=clapperboard%20and%20film%20reels%20stacked%20on%20a%20director%20chair%20in%20a%20dim%20studio%2C%20crimson%20and%20charcoal%20tones%2C%20stylized%20abstract%20editorial%20photography%2C%20no%20people&width=900&height=675&seq=xg-drama-shortfilm-07&orientation=landscape',
    participants: ['原创团队「拾光短剧」', '涉事制作方', '播出平台'],
    tags: ['短剧', '抄袭', '版权'],
    startedAt: '2026-07-02',
    updatedAt: '2026-09-01',
    progress: 52,
    timeline: [
      {
        date: '2026-07-02',
        title: '一份长达十八页的比对文档',
        content:
          '拾光短剧发布一份比对文档，逐集列出两部短剧在人物关系、关键转折与台词上的相似之处，共统计出十八页对照内容。文档迅速在从业者圈内流传。',
        type: 'start',
      },
      {
        date: '2026-07-09',
        title: '涉事方回应：撞梗属于常态',
        content:
          '涉事制作方回应称，短剧题材高度同质化，类似桥段在行业内十分常见，双方创作时间接近，不存在抄袭行为，并表示愿意就争议进行沟通。',
        type: 'update',
      },
      {
        date: '2026-08-14',
        title: '反转：创作时间线材料出现',
        content:
          '拾光短剧补充提交了剧本修改记录与拍摄通告单，显示其创作与开机时间均早于对方。对方则以「早期版本从未公开」为由，对时间先后的证明力提出质疑。',
        type: 'twist',
      },
      {
        date: '2026-09-01',
        title: '进度：平台介入下架比对',
        content:
          '播出平台表示已受理投诉，对涉事短剧的部分剧集作下架处理，同时要求双方补充权属材料。最终结论尚未公布，本瓜仍在更新。',
        type: 'update',
      },
    ],
  },
  {
    id: 'yin-yue-jie-qu-xiao',
    title: '音乐节临时取消：三万人到场，舞台在黑屏中熄灭',
    category: 'wanghong',
    status: 'ended',
    heat: 4890,
    summary: '一场官宣三个月、门票售罄的音乐节在开场前两小时宣布取消，主办方、场地方与艺人的说法各不相同。',
    cover:
      'https://readdy.ai/api/search-image?query=empty%20outdoor%20music%20festival%20stage%20at%20dusk%20with%20unlit%20lights%20and%20empty%20standing%20area%2C%20dusty%20orange%20sky%2C%20melancholic%20stylized%20editorial%20photography%2C%20no%20people&width=900&height=675&seq=xg-drama-festival-08&orientation=landscape',
    participants: ['主办方「声浪文化」', '场地方', '购票观众'],
    tags: ['音乐节', '票务', '退款'],
    startedAt: '2026-04-06',
    updatedAt: '2026-05-28',
    progress: 100,
    timeline: [
      {
        date: '2026-04-06',
        title: '开场前两小时的一纸公告',
        content:
          '原定下午两点开场的音乐节，在中午十二点发布「因不可抗力取消」的公告。此时已有大量观众抵达现场，相关视频与照片迅速扩散。',
        type: 'start',
      },
      {
        date: '2026-04-07',
        title: '三方各执一词',
        content:
          '主办方称场地临时无法提供电力保障；场地方则表示主办方尾款未结清；部分已到场的艺人团队称从未收到取消通知。三方说法互不吻合，让事件迅速发酵。',
        type: 'update',
      },
      {
        date: '2026-04-15',
        title: '反转：结算记录被公开',
        content:
          '主办方公开部分转账记录，称场地方临时提高费用并中断供电。场地方随后回应称该笔费用为先前约定的超时使用费，双方就「谁先违约」展开争论。',
        type: 'twist',
      },
      {
        date: '2026-05-28',
        title: '结局：全额退款并补偿交通费',
        content:
          '主办方公布退款方案，对所有购票观众全额退票，并按票面价的一定比例补贴外地观众的交通支出，同时宣布暂停举办后续场次。事件最终以此落幕。',
        type: 'ending',
      },
    ],
  },
];